import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import React from 'react';
import { Icon } from 'react-feather';

interface UserMenuItemProps extends MenuItemProps {
  icon?: Icon;
}

const UserMenuItem = ({
  children,
  icon: IconComponent,
  ...props
}: UserMenuItemProps): React.JSX.Element => {
  return (
    <MenuItem {...props}>
      {IconComponent && (
        <IconComponent size={16} className="mr-8 shrink-0 text-on-surface-secondary" />
      )}
      {children}
    </MenuItem>
  );
};

export default UserMenuItem;
